module.exports = __webpack_public_path__ + "static/insight-logo-small-373dc8f1093903273c3e0c61abb82e40.jpg";